var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var getId = function getId() {
  return "".concat(new Date().getTime()).concat(Math.random() * 100);
};
var Queue = /** @class */function () {
  function Queue() {
    this.cacheInfo = [];
    this.cacheInfo = [];
  }
  Queue.prototype.add = function (level, data, label) {
    var id = getId();
    this.cacheInfo.push(__assign(__assign({}, data), {
      id: id,
      level: level,
      label: label
    }));
    return id;
  };
  Queue.prototype.update = function (id, level, data, label) {
    var list = this.cacheInfo;
    var findIndex = list.findIndex(function (item) {
      return item.id === id;
    });
    if (findIndex < 0) {
      return this.add(level, data, label);
    }
    this.cacheInfo.splice(findIndex, 1, __assign(__assign({}, data), {
      id: id,
      level: level,
      label: label
    }));
    return id;
  };
  Queue.prototype.getAll = function () {
    var result = this.cacheInfo.map(function (item) {
      delete item.id;
      return item;
    });
    return JSON.stringify(result);
  };
  Queue.prototype.removeAll = function () {
    this.cacheInfo = [];
  };
  Queue.prototype.has = function (limitCount) {
    if (limitCount) {
      return this.cacheInfo.length >= limitCount;
    }
    return this.cacheInfo.length > 0;
  };
  return Queue;
}();
export default Queue;